module.exports = __webpack_public_path__ + "img/textos-escritorio-mobile-2.b55d2805.png";